module.exports = __webpack_public_path__ + "static/media/uploadsuccess.f6c19f13.png";